import { Message } from 'element-ui'
import * as apis from 'common-mediax/src/apis'
// import { start } from 'qiankun'
import { routeIdTable } from '@/configs/route-config'
import { routerFormat, getOpenUrl } from '@common/handleModules'
import EventBus from 'common-mediax/src/common/EventBus'
import GlobalEvent, { EventBusDataKey } from '@common/GlobalEvent'
import RegisterAuths from '@/configs/register-auths'
import YQFontConfig from 'common-mediax/src/common/preferenceSetting/setFont.js'
/**
 * 获取租户配置中的偏好信息
 * @param store
 */
function getPreference(store) {
  // 获取租户配置中的偏好信息
  return apis.MediaCloudSystemSetting.getConfigPreference({}).then((res) => {
    if (res.data?.status === 0) {
      // 更新平台偏好设置
      store.commit('micro/SET_SYSTEM_PREFERENCE', res.data.data)
      return res
    } else {
      return res
    }
  })
}

/**
 * 与 Login.getFirstMenu 一致：解析首个可进入的业务菜单路由配置
 * @param {Object} groups - 权限分组
 * @param {Array} auths - 权限列表
 * @param {boolean} firstGroupsIsSystem - 是否为首组系统
 * PS：需求831129 
 */
function getFirstMenuRouteConfig(groups, auths, firstGroupsIsSystem) {
  let firstMenu = null
  let firstSubs = []
  if (firstGroupsIsSystem) {
    firstSubs = JSON.parse(
      JSON.stringify((groups[1] && groups[1].subs) || [])
    )
  } else {
    firstSubs = JSON.parse(
      JSON.stringify((groups[0] && groups[0].subs) || [])
    )
  }
  const authList = auths || []
  if (firstSubs && firstSubs.length > 0) {
    for (const subs of firstSubs) {
      if (!firstMenu && subs.mods && subs.mods.length) {
        subs.mods.find((mod) => {
          if (
            mod.source &&
            mod.type == 0 &&
            authList.indexOf(mod.source) > -1 &&
            !firstMenu
          ) {
            firstMenu = mod
            return mod
          }
          if (
            mod.mods &&
            mod.mods.find((mod2) => {
              if (
                mod2.source &&
                mod2.type == 0 &&
                authList.indexOf(mod2.source) > -1 &&
                !firstMenu
              ) {
                firstMenu = mod2
                return mod2
              }
              return false
            })
          ) {
            return firstMenu
          }
          return false
        })
      }
    }
  }
  if (firstMenu) {
    return routeIdTable.find((config) => config.mod === firstMenu.code)
  }
  return false
}

/**
 * 与 Login/index.vue 登录成功后对个人偏好的处理保持一致（字体、AI 助手、列表加粗、万资源地址等）
 * @param {Object} data - 个人偏好数据
 * PS：需求831129 
 */
function applyMainUserPreferenceLikeLogin(data) {
  if (!data) return
  if (data.customSetting && data.fontFamily) {
    window.localStorage.setItem('yqCustomSettingFontFamily', data.fontFamily)
  } else {
    window.localStorage.removeItem('yqCustomSettingFontFamily')
  }
  EventBus.setData(
    EventBusDataKey.AUTH.AI_ASSISTANT_SWITCH,
    data.aiAssistantSwitch
  )
  YQFontConfig.setConfig(data)
  if (data.listFontBold) {
    window.localStorage.setItem('yqCustomSettingListFontBold', 'Bold')
  } else {
    window.localStorage.removeItem('yqCustomSettingListFontBold')
  }
  if (data.wanResUrl) {
    window.localStorage.setItem('yqCustomSettingWanResUrl', data.wanResUrl)
  } else {
    window.localStorage.removeItem('yqCustomSettingWanResUrl')
  }
}

/**
 * 已拉门户权限后，按「跳过首页」解析首个业务菜单路径（与 Login.getFirstMenu + goPath 一致）
 * @param {Object} store - 存储
 * PS：需求831129 
 */
async function resolveSkipHomeRedirect(store) {
  const authObj = new RegisterAuths()
  await authObj.getAuths()
  await store.dispatch('micro/getVersion')

  const groups = EventBus.getData(EventBusDataKey.AUTH.GROUPS)
  const auths = EventBus.getData(EventBusDataKey.AUTH.AUTHS)
  const firstGroupsIsSystem = !!EventBus.getData(
    EventBusDataKey.AUTH.FIRST_GROUPS_IS_SYSTEM
  )
  if (!groups || !groups.length || !groups._mods) {
    return null
  }

  const firstRouteConfig = getFirstMenuRouteConfig(
    groups,
    auths,
    firstGroupsIsSystem
  )
  if (!firstRouteConfig) {
    return null
  }
  const route = groups._mods.find((g) => firstRouteConfig.route === g.route)
  if (!route) {
    return null
  }
  return {
    path: '/service/' + route.route,
    casId: route.casId
  }
}

/**
 * checksum / checkSumRemoteMediax 登录成功后：先请求并应用 getMainUserPreference（与 Login/index.vue 一致），
 * 若 skipHome 再跳转首个业务菜单；否则返回 null 走原 openUrl
 * PS：需求831129 
 */
async function afterRemoteLoginUserPreferenceAndMaybeSkipHome(store) {
  const preference = await apis.MediaCloudGateway.getMainUserPreference({})
  if (preference.data?.status !== 0 || !preference.data?.data) {
    return null
  }
  applyMainUserPreferenceLikeLogin(preference.data.data)
  if (!preference.data.data.skipHome) {
    return null
  }
  return resolveSkipHomeRedirect(store)
}

export default function permission(store, router) {
  router.beforeEach(async (to, from, next) => {
    await routerFormat(to, from, next)
    if (to.name === 'Login') {
      let loginInfo = window.localStorage.getItem('loginInfo')
      // 屏蔽掉Batman登录，因为batman没有home页
      if (
        loginInfo &&
        process.env.MODE !== 'PUGC' &&
        process.env.MODE !== 'RR'
      ) {
        // 如果用户已经登录，再次进入登录页面直接进入到首页
        next('/')
        return
      }
      window.localStorage.removeItem('yqSystemTime')
      window.localStorage.removeItem('loginInfo')
      window.localStorage.removeItem('rrLoginUserInfo')
      window.localStorage.removeItem('tianmuyun')
      window.localStorage.removeItem('yqDefaultLogin')
      window.localStorage.removeItem('lastSeenMessageId') // 退出登录清空全局消息弹窗记录
      if (process.env.MODE === 'PUGC') {
        window.localStorage.removeItem('pugcConfig')
        window.localStorage.removeItem('authenticationInfo')
        // 请求/获取TICKET
        store
          .dispatch('batman/FETCH_TOKEN')
          .then(() => {
            next()
          })
          .catch(() => {
            next()
          })
      } else {
        apis.MediaCloudGateway.getCasConfig({})
          .then((resp) => {
            if (resp.data && resp.data.status === 0 && resp.data.data) {
              window.location.href = resp.data.data
            } else {
              next()
            }
          })
          .catch(() => {
            next()
          })
      }
    } else {
      if (to.query && to.query.al) {
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', false)
        // 单点登录只显示芯，不显示框架
        window.localStorage.removeItem('yqSystemTime')
        window.localStorage.removeItem('loginHideStyle')
        window.localStorage.removeItem('tianmuyun')
        apis.MediaCloudGateway.postAutoLogin({
          headers: { 'Content-Type': 'text/plain' },
          data: to.query.al
        }).then((res) => {
          if (res.data.status === 0) {
            store.commit('micro/SAVE_LOGIN_INFO', res.data.data)
            window.localStorage.setItem('autoLogin', true)
            next()
          }
        })
      } else if (to.query && to.query.cld) {
        // 单点登录到云端稿库
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', false)
        // 单点登录只显示芯，不显示框架
        window.localStorage.removeItem('yqSystemTime')
        window.localStorage.removeItem('loginHideStyle')
        window.localStorage.removeItem('tianmuyun')
        apis.MediaCloudGateway.postAutoLogin({
          headers: { 'Content-Type': 'text/plain' },
          data: to.query.cld
        }).then((res) => {
          if (res.data.status === 0) {
            store.commit('micro/SAVE_LOGIN_INFO', res.data.data)
            next()
          }
        })
      } else if (to.query && to.query.fl) {
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', false)
        // 单点登录天目蓝云，直接进入框架内，有导航
        window.localStorage.removeItem('yqSystemTime')
        window.localStorage.removeItem('autoLogin')
        window.localStorage.setItem('tianmuyun', true)
        // 暂时屏蔽掉logout逻辑
        // apis.MediaCloudGateway.postLogout({ closeErrorMsg: true }).then(
        //   (res) => {
        //     if (res.data.status === 0 || res.data.status === 401) {
        // 更改逻辑，不需要前端通过获取checksum，改为在地址栏获取
        // apis.MediaCloudGateway.getLoginCheckSum({
        //   params: {
        //     clientCode: to.query.clientCode,
        //     accessToken: to.query.accessToken
        //   }
        // }).then((res) => {
        //   if (res.data.status === 0) {

        apis.MediaCloudGateway.postAutoLogin({
          headers: { 'Content-Type': 'text/plain' },
          data: to.query.fl
        }).then((res) => {
          if (res.data.status === 0) {
            store.commit('micro/SAVE_LOGIN_INFO', res.data.data)
            // 获取到loginInfo之后再去判断是否需要获取授权，否则mods接口会401
            // getAuthStorage()
            // 屏蔽一系列的功能按钮
            getPreference(store).then((res) => {
              if (res.data.status === 0) {
                if (res.data.data) {
                  if (res.data.data.hasOwnProperty('loginHideStyle')) {
                    window.localStorage.setItem(
                      'loginHideStyle',
                      res.data.data.loginHideStyle
                    )
                  }
                  window.localStorage.setItem(
                    'paperCustomStyle',
                    res.data.data.paperCustomStyle
                  )
                  // 获取租户配置中的偏好信息-设置天目蓝云主题
                  if (res.data.data.paperCustomStyle) {
                    document
                      .getElementById('app')
                      .setAttribute('class', 'them_tmly')
                  }
                  // 偏好设置-消息弹窗是否显示
                  if (res.data.data.hasOwnProperty('messageShowPopup')) {
                    window.localStorage.setItem(
                      'messageShowPopup',
                      res.data.data.messageShowPopup
                    )
                  }
                }
                next()
              }
            })
          }
        })
      } else if (to.query && to.query.isCas && to.query.ticket) {
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', false)
        // 单点登录暨南大学，进入home页
        window.localStorage.removeItem('yqSystemTime')
        window.localStorage.removeItem('autoLogin')
        window.localStorage.removeItem('loginHideStyle')
        window.localStorage.removeItem('tianmuyun')

        apis.MediaCloudGateway.getCasLogin({
          params: to.query
        }).then((res) => {
          if (res.data.status === 0) {
            apis.MediaCloudGateway.postAutoLogin({
              headers: {
                'Content-Type': 'text/plain'
              },
              data: res.data.data.checksum
            }).then((res) => {
              if (res.data.status === 0) {
                store.commit('micro/SAVE_LOGIN_INFO', res.data.data)
                // 获取到loginInfo之后再去判断是否需要获取授权，否则mods接口会401
                // getAuthStorage()
                next()
              }
            })
          }
        })
      } else if (to.query && to.query.checkSum) {
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', false)
        // 翔宇对接云雀，直接进入框架内，有导航
        window.localStorage.removeItem('yqSystemTime')
        window.localStorage.removeItem('autoLogin')
        window.localStorage.removeItem('loginHideStyle')
        window.localStorage.removeItem('tianmuyun')

        apis.MediaCloudGateway.postAutoLogin({
          headers: {
            'Content-Type': 'text/plain'
          },
          data: to.query.checkSum
        }).then((res) => {
          if (res.data.status === 0) {
            store.commit('micro/SAVE_LOGIN_INFO', res.data.data)
            // 获取到loginInfo之后再去判断是否需要获取授权，否则mods接口会401
            // getAuthStorage()
            const query = Object.assign({}, to.query)
            delete query.checkSum // 解决单点登录之后刷新页面偶现微应用died问题
            let openUrl = getOpenUrl({
              url: to.path,
              params: query
            })
            next(openUrl)
            // next()
          }
        })
      } else if (to.query && to.query.checkSumRemoteMediax) {
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', true)
        // 翔宇对接云雀，直接进入框架内，有导航
        window.localStorage.removeItem('yqSystemTime')
        window.localStorage.removeItem('autoLogin')
        window.localStorage.removeItem('loginHideStyle')
        window.localStorage.removeItem('tianmuyun')

        apis.MediaCloudGateway.postAutoLoginRemoteMediax({
          headers: {
            'Content-Type': 'text/plain'
          },
          data: to.query.checkSumRemoteMediax
        }).then(async (res) => {
          if (res.data.status === 0) {
            store.commit('micro/SAVE_LOGIN_INFO', res.data.data)
            const query = Object.assign({}, to.query)
            delete query.checkSumRemoteMediax // 解决单点登录之后刷新页面偶现微应用died问题
            let openUrl = getOpenUrl({
              url: to.path,
              params: query
            })
            // 与 Login/index.vue 一致：先 getMainUserPreference 应用偏好，再按 skipHome 决定是否进首个菜单
            // PS：需求831129 
            try {
              const redirect = await afterRemoteLoginUserPreferenceAndMaybeSkipHome(
                store
              )
              if (redirect && redirect.path) {
                store.commit('micro/SET_NAV_IDS', { casId: redirect.casId })
                next(redirect.path)
                return
              }
            } catch (e) {
              console.warn('[getMainUserPreference] checkSumRemoteMediax:', e)
            }
            next(openUrl)
          } else {
            Message.error({
              message: '账号状态异常，请联系管理员',
              duration: 1500
            })
            // 获取当前URL
            //两秒后跳转登录页
            setTimeout(() => {
              var currentUrl = window.location.origin
              window.location.href = currentUrl + '/login' // 在当前窗口打开
            }, 2000)
          }
        })
      } else {
        // 正常登录云雀
        // 这个缓存参数数据判断目前仅用于判断是否屏蔽首页的跳过首页功能权限，不具有其他实际意义
        window.localStorage.setItem('yqDefaultLogin', true)
        window.localStorage.removeItem('autoLogin')
        let loginInfo = localStorage.getItem('loginInfo')
        try {
          loginInfo = JSON.parse(loginInfo)
        } catch (err) {
          console.log(err)
        }
        if (loginInfo && loginInfo.authToken) {
          const isRR = process.env.MODE === 'RR'
          // if else 顺序要明确哈
          if (process.env.MODE === 'PUGC') {
            next()
          }
          // BUG #629582 从主页其他菜单进去后，点击应用中心，弹出无权限后跳转到portal页 先加个 from !== ''
          else if (to.name === 'Home' || from.name === 'Login') {
            // 更换主题
            getPreference(store).then((res) => {
              if (res.data.data.hasOwnProperty('paperCustomStyle')) {
                window.localStorage.setItem(
                  'paperCustomStyle',
                  res.data.data.paperCustomStyle
                )
              }
              // 屏蔽按钮
              if (res.data.data.hasOwnProperty('loginHideStyle')) {
                window.localStorage.setItem(
                  'loginHideStyle',
                  res.data.data.loginHideStyle
                )
              }
              // 稿签显示人员信息使用（架构坚持放在这
              if (res.data.data.hasOwnProperty('authorDefaultShow')) {
                window.localStorage.setItem(
                  'yqAuthorDefaultShow',
                  res.data.data.authorDefaultShow === true ? 1 : 0
                )
              }
              // 稿签显示人员信息使用（架构坚持放在这
              if (res.data.data.hasOwnProperty('editorDefaultShow')) {
                window.localStorage.setItem(
                  'yqEditorDefaultShow',
                  res.data.data.editorDefaultShow === false ? 0 : 1
                )
              }
              // 自动设置标题图（和获取编辑页面获取是否默认填写作者编辑稿签逻辑保持一致
              if (res.data.data.hasOwnProperty('autoSetTitleImage')) {
                window.localStorage.setItem(
                  'yqAutoSetTitleImage',
                  res.data.data.autoSetTitleImage === true ? 1 : 0
                )
              }
              // 大样版面图预览页背景设置为白色
              if (res.data.data.hasOwnProperty('fullPageBackground')) {
                window.localStorage.setItem(
                  'yqFullPageBackground',
                  res.data.data.fullPageBackground === true ? 1 : 0
                )
              }
              // 是否显示公告
              if (res.data.data.hasOwnProperty('messageShowNotice')) {
                window.localStorage.setItem(
                  'yqMessageShowNotice',
                  res.data.data.messageShowNotice === false ? 0 : 1
                )
              }
              // 偏好设置-消息弹窗是否显示
              if (res.data.data.hasOwnProperty('messageShowPopup')) {
                window.localStorage.setItem(
                  'messageShowPopup',
                  res.data.data.messageShowPopup
                )
              }
              store.commit('micro/SAVE_LOGIN_INFO', loginInfo)
              next()
            })
          } else if (!isRR) {
            getPreference(store)
            // 这句话真的生效了吗？深表怀疑
            store.commit('micro/SAVE_LOGIN_INFO', loginInfo)

            let authsArr = EventBus.getData(EventBusDataKey.AUTH.AUTHS) || []
            if (to && to.name === 'service' && to.path) {
              if (!authsArr || !authsArr.length) {
                // 获取权限信息
                let authObj = new RegisterAuths()
                await authObj.getAuths()
                authsArr = EventBus.getData(EventBusDataKey.AUTH.AUTHS)
              }
              sessionStorage.setItem('routerToPath', to.path)

              let routeObj = routeIdTable.find(
                (item) =>
                  '/service' + item.route === to.path ||
                  '/service' + item.route + '/index' === to.path
              )
              if (
                routeObj &&
                routeObj.mod &&
                !authsArr.includes(routeObj.mod)
              ) {
                sessionStorage.setItem('routerAuthError', routeObj.mod)
                Message.error({
                  message: '您没有权限访问该页面',
                  duration: 1500
                })
                next('/home')
              } else {
                next()
              }
            } else {
              next()
            }
          } else {
            next()
          }
        } else {
          if (from.name === 'Login') {
            window.localStorage.removeItem('loginInfo')
            Message.error({
              message: '当前未登录，请先登录',
              duration: 2000
            })
          } else if (from.name) {
            window.localStorage.removeItem('loginInfo')
            Message.error({
              message: '登录验证失败，即将返回登录页',
              duration: 2000
            })
          }

          const query = Object.assign({}, to.query)
          setTimeout(function () {
            // 这里是内容快运必要的link参数 防止跳登录页参数丢失用
            if (query && (query.linkUrl || query.linkurl)) {
              next({
                path: '/login',
                query: query
              })
            } else {
              if (process.env.MODE === 'PUGC') {
                let siteId = localStorage.getItem('siteId')
                next(`/login?siteId=${siteId}`)
              } else {
                next('/login')
              }
            }
          }, 2000)
        }
        let conf = localStorage.getItem('yqConfig')
        if (process.env.MODE === 'PUGC') {
          conf = localStorage.getItem('pugcConfig')
        }
        let $favicon = document.querySelector('link[rel="icon"]')
        let convertBase64ToBlob = (base64) => {
          if (!base64) return null
          // 将base64解码
          let bytes = atob(base64)
          //var bytes = base64;
          let bytesCode = new ArrayBuffer(bytes.length)
          // 转换为类型化数组
          let byteArray = new Uint8Array(bytesCode)

          // 将base64转换为ascii码
          for (let i = 0; i < bytes.length; i++) {
            byteArray[i] = bytes.charCodeAt(i)
          }
          const blob = new Blob([bytesCode], { type: 'image/*' })
          const url = (window.URL || window.webkitURL).createObjectURL(blob)
          // 生成Blob对象（文件对象）
          return url
        }
        if (conf) {
          conf = JSON.parse(conf)
          const title =
            process.env.MODE === 'RR'
              ? '云端稿库'
              : process.env.MODE === 'PUGC'
                ? 'PUGC投稿平台'
                : '云雀融媒体'
          document.title = conf.name || title

          if ($favicon !== null) {
            $favicon.href =
              conf.browserLogo ||
              (process.env.MODE === 'RR'
                ? '/company_logo_rr_new.png'
                : '/company_logo.png')
            // convertBase64ToBlob(conf.browserLogoUrl) || '/company_logo.png'
          }
        } else {
          if ($favicon !== null) {
            $favicon.href =
              process.env.MODE === 'RR'
                ? '/company_logo_rr_new.png'
                : '/company_logo.png'
          }
        }
      }
    }

    if (!window.localStorage.getItem('yqSystemTime')) {
      apis.MediaCloudSystemAuthoryOverview.getSystemTime({}).then((resp) => {
        if (resp.data.status === 0) {
          let systemTime = Number(resp.data.data) - Number(new Date().getTime())
          window.localStorage.setItem('yqSystemTime', systemTime)
        }
      })
    }

    if (process.env.MODE === 'PUGC') {
      try {
        let virtualDeviceId = window.localStorage.getItem(
          'batman_virtualDeviceId'
        )
        if (!virtualDeviceId) {
          let d = new Date().getTime()
          let _ss = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxxxxxx'.replace(
            /[xy]/g,
            function (c) {
              let r = (d + Math.random() * 16) % 16 | 0
              d = Math.floor(d / 16)
              return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
            }
          )
          window.localStorage.setItem('batman_virtualDeviceId', _ss)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })
}
